<div class="position-fixed d-flex justify-content-center align-items-center"
    style="width: 100%; height: 100vh;top: 0;z-index: 1;background: rgba(0,0,0,0.5);" *ngIf="uploading_spinner">
    <mat-spinner></mat-spinner>
</div>
<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Push Data To Nimbus</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3">
                        <mat-select placeholder="Lead Source" [(ngModel)]="lead_source"
                            (click)="setSearchValue('lead_source')" multiple>
                            <input class="mySearchInput" #leadsourceSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_source')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="leadsourceSearch">
                            <mat-option value="{{lsources.id}}"
                                *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <mat-select placeholder="Lead Status" [(ngModel)]="lead_status"
                            (click)="setSearchValue('lead_status')" multiple>
                            <input class="mySearchInput" #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="lead_status_Search">
                            <mat-option value="{{lstatus.id}}"
                                *ngFor="let lstatus of leadStatus">{{lstatus.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <mat-select placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple
                            #itemSelect="ngModel">
                            <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <mat-select placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')"
                            multiple>
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-2">
                        <mat-select placeholder="Treatment" [(ngModel)]="treatment"
                            (click)="setSearchValue('treatment')" multiple>
                            <input class="mySearchInput" #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="treatmentSearch">
                            <mat-option value="{{ltreatment.id}}"
                                *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-2">
                        <mat-select placeholder="Lead Catergory" [(ngModel)]="lead_category_filter"
                            (click)="setSearchValue('leadCategory')" multiple>
                            <input class="mySearchInput" #leadcategorySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'leadCategory')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="leadcategorySearch">
                            <mat-option value="{{catergory.id}}"
                                *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-2">
                        <mat-select placeholder="Payment Mode" [(ngModel)]="payment_mode" multiple>
                            <mat-option value="Cash">Cash</mat-option>
                            <mat-option value="Cashless">Cashless</mat-option>
                            <mat-option value="Reimbursement">Reimbursement</mat-option>
                            <mat-option value="EMI">EMI</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon class="cursor" (click)="clearDate()">clear</mat-icon>
                    </div>
                    <div
                        *ngIf="lead_source || lead_status ||bd||circle||treatment||lead_category_filter || payment_mode || end_date">

                        <button type="button" [disabled]="loading_spinner" class="btn btn-primary ml-2 mb-4 mt-2"
                            (click)="loadPushDataList()">
                            <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4 mt-2" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>

                    </div>

                    <div class="col-sm-3 mt-2" *ngIf="campaign_name_dropdown">
                        <mat-select placeholder="Campaign Name" [(ngModel)]="campaign_name"
                            (click)="setSearchValue('campaign_name')">
                            <input class="mySearchInput" #campaign_nameSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'campaign_name')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="campaign_nameSearch">
                            <mat-option [value]="data.campaign_id"
                                *ngFor="let data of campaign_data">{{data.campaign_name}}({{data.campaign_id}})</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-2" *ngIf="campaign_name">
                        <mat-select placeholder="List Name" [(ngModel)]="list_id" (selectionChange)="loadPushDataList()"
                            (click)="setSearchValue('list_name')">
                            <input class="mySearchInput" #list_nameSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'list_name')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="list_nameSearch">
                            <mat-option [value]="data.list_id"
                                *ngFor="let data of listName">{{data.list_name}}({{data.list_id}})</mat-option>
                        </mat-select>
                    </div>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <hr>
        <div *ngIf="dump_total>0">
            <div [innerHTML]="paging_html_dump | safe:'html'"> </div>
        </div>
        <div class="text-center" *ngIf="loading_spinner">
            <i class="fa fa-spin fa-spinner fa-2x"></i>
        </div>
    </div>
</div>